import { render } from "./NavigationLayout.vue?vue&type=template&id=2a6b9d5d"
import script from "./NavigationLayout.vue?vue&type=script&lang=js"
export * from "./NavigationLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__